module.exports = __webpack_public_path__ + "img/placeholder_1_16to9.f313ad1b.svg";